export const TABLE_CONSTANTS = {
  GRAND_TOTAL_ID: 'unique_grand_total_shop_id',
  GRAND_AVERAGE_ID: 'unique_grand_average_id',
  EMPTY_GUID: '00000000-0000-0000-0000-000000000000'
}

/** Table view / Chart view switch shown in a summary page's header. */
export type ViewMode = 'table' | 'chart'
